import api from '../config/axiosConfig';

export const fetchPlatformOverview = async () => {
  const { data } = await api.get('/analytics/admin/platform-overview');
  return data;
};

export const fetchActivityByPeriod = async (filter: string) => {
  const { data } = await api.get(
    `/analytics/admin/activity-by-period?filter=${filter}`,
  );
  return data;
};

export const fetchCampaignsOverview = async (filter: string) => {
  const { data } = await api.get(
    `/analytics/admin/campaigns-overview?filter=${filter}`,
  );
  return data;
};

export const fetchRevenueTrend = async () => {
  const { data } = await api.get('/analytics/admin/revenue-trend');
  return data;
};

export const fetchRoasTrend = async () => {
  const { data } = await api.get('/analytics/admin/roas-trend');
  return data;
};

export const fetchTopBrandsByGmv = async (limit = 5) => {
  const { data } = await api.get(`/analytics/admin/top-brands?limit=${limit}`);
  return data;
};

export const fetchTopCreatorsByGmv = async (limit = 5) => {
  const { data } = await api.get(
    `/analytics/admin/top-creators?limit=${limit}`,
  );
  return data;
};

export const fetchTopCampaignsByGmv = async (limit = 5) => {
  const { data } = await api.get(
    `/analytics/admin/top-campaigns?limit=${limit}`,
  );
  return data;
};

export const fetchSubmissionsStats = async (filter: string) => {
  const { data } = await api.get(
    `/analytics/admin/submissions-stats?filter=${filter}`,
  );
  return data;
};

export const fetchGmvGrowth = async (months = 12) => {
  const { data } = await api.get(
    `/analytics/admin/gmv-growth?months=${months}`,
  );
  return data;
};

export const fetchBudgetOverview = async () => {
  const { data } = await api.get('/analytics/admin/budget-overview');
  return data;
};

export const fetchBrandCategoryDistribution = async () => {
  const { data } = await api.get(
    '/analytics/admin/brand-category-distribution',
  );
  return data;
};

export const fetchCreatorRetention = async () => {
  const { data } = await api.get('/analytics/admin/creator-retention');
  return data;
};

export const fetchContentPerformance = async () => {
  const { data } = await api.get('/analytics/admin/content-performance');
  return data;
};

export const fetchGeographicDistribution = async () => {
  const { data } = await api.get('/analytics/admin/geographic-distribution');
  return data;
};

export const fetchPlatformComparison = async () => {
  const { data } = await api.get('/analytics/admin/platform-comparison');
  return data;
};

export interface AdminSubmissionsListParams {
  page?: number;
  limit?: number;
  status?: string;
  platform?: string;
  campaignId?: string;
  brandId?: string;
  search?: string;
}

export const fetchAdminSubmissionsList = async (
  params: AdminSubmissionsListParams = {},
) => {
  const { data } = await api.get('/analytics/admin/submissions', { params });
  return data;
};

export interface AdminCampaignListParams {
  page?: number;
  limit?: number;
  status?: string;
  search?: string;
  platform?: string;
  brandId?: string;
}

export const fetchAdminCampaignsList = async (
  params: AdminCampaignListParams = {},
) => {
  const { data } = await api.get('/analytics/admin/campaigns', { params });
  return data;
};

export const fetchAdminCampaignDetail = async (campaignId: string) => {
  const { data } = await api.get(`/analytics/admin/campaigns/${campaignId}`);
  return data;
};

export const setCampaignCountryPause = async (
  campaignId: string,
  country: string,
  paused: boolean,
): Promise<string[]> => {
  const { data } = await api.put(
    `/admin/campaigns/${campaignId}/country-pause`,
    { country, paused },
  );
  return data.pausedCountries ?? [];
};
